export function isStringifiable(o?: any): o is { toString(): string } {
    return typeof o?.toString === 'function';
}
